// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PScissorOutlinedSvg from "@fishx/icons-svg/es/asn/PScissorOutlined";
import FishxIcon from '../components/FishxIcon';

var PScissorOutlined = function PScissorOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PScissorOutlinedSvg
  }));
};

PScissorOutlined.displayName = 'PScissorOutlined';
export default React.forwardRef(PScissorOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PScissorOutlined.js
// module id = 3620
// module chunks = 0